import React from 'react';
import { X } from 'lucide-react';
import styles from './LoginModal.module.css';

const LoginModal = ({ isOpen, onClose, onLogin, message }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <div className={styles.closeButtonContainer}>
          <button className={styles.closeButton} onClick={onClose}>
            <X size={24} color="#fff" />
          </button>
        </div>
        <div className={styles.modalContent}>
          <h2 className={styles.modalTitle}>Login Required</h2>
          <p className={styles.modalMessage}>
            {message || "You have to login first for this action"}
          </p>
          <div className={styles.buttonContainer}>
            <button className={styles.loginButton} onClick={onLogin}>
              Login
            </button>
            <button className={styles.cancelButton} onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;